import React from 'react';
import Typography from '@bexs/dollar/components/Typography';
import FlexBox from '@bexs/dollar/components/Flex';

const NotFound: React.FC = () => (
  <FlexBox
    style={{ height: '100vh', width: '100%' }}
    alignItems="center"
    justifyContent="center"
  >
    <Typography as="h3">Not found</Typography>
  </FlexBox>
);

export default NotFound;
